"use client";

import { useState } from "react";
import { usePathname } from "next/navigation";
import { trackEvent } from "@/lib/posthog";
import FeedbackModal from "@/components/FeedbackModal";

const HIDDEN_PATHS = ["/login", "/onboarding", "/processing", "/admin", "/results"];

export default function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  if (HIDDEN_PATHS.some((p) => pathname.startsWith(p))) return null;

  return (
    <>
      <button
        onClick={() => { setOpen(true); trackEvent("feedback_opened"); }}
        className="fixed bottom-24 right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-on-primary shadow-lg transition-transform hover:scale-105 active:scale-95"
        aria-label="Donnez votre avis"
      >
        <span className="material-symbols-outlined text-xl">rate_review</span>
      </button>
      <FeedbackModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
